import initVueApp from "@/core.js";
const component = require(`./../views/Register.vue`).default;
initVueApp(component);
